import Flex from '../Flex';
const Tag = ({ text, ...restProps }) => (
  <Flex className='custom-tag' {...restProps}>
    {text}
  </Flex>
);

export default Tag;
